import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://www.hoperoad.life';

/**
 * Syncs the canonical link tag with the current client-side route.
 */
function CanonicalLink() {
  const location = useLocation();

  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const canonicalHref = new URL(location.pathname, SITE_URL).toString();
    let canonicalTag = document.querySelector('link[rel="canonical"]');

    if (!canonicalTag) {
      canonicalTag = document.createElement('link');
      canonicalTag.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalTag);
    }

    canonicalTag.setAttribute('href', canonicalHref);
  }, [location]);

  return null;
}

export default CanonicalLink;
